import { GetterTree } from 'vuex';
import { EstimateDataType, EstimateStateType } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<EstimateStateType, any> = {
  getEstimateData(state: EstimateStateType): EstimateDataType | null {
    return state.estimateData;
  },
  getEstimateSignatureOption(state: EstimateStateType): string {
    return state.estimateData.signatureOptions;
  },
};

export default getters;
